module.exports = __webpack_public_path__ + "static/img/car9.923c332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car9.png
// module id = uGHD
// module chunks = 1